module.exports = __webpack_public_path__ + "static/media/logo.00ace951.png";